var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplainerVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.709,
    height: 96.709,
    viewBox: "0 0 96.709 96.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135473",
    "data-name": "Path 135473",
    d: "M48.4,0A48.355,48.355,0,1,1,0,48.306v-.077A48.355,48.355,0,0,1,48.4,0ZM44.709,36.75H36.082a7.22,7.22,0,0,0-1.857.261,1.8,1.8,0,0,0-1.412,1.5,1.722,1.722,0,0,0,.967,1.992,8.788,8.788,0,0,0,2.95.793c2.689.126,3.772,1.306,3.365,4.071-.754,5.174-1.77,10.309-2.64,15.473-.59,3.482-1.083,6.973-1.654,10.454-.764,4.69,3.607,9.091,7.079,9.671a41.285,41.285,0,0,0,6.209.4,16.164,16.164,0,0,0,11.75-5.087,4.466,4.466,0,0,0,1.209-1.866,2.29,2.29,0,0,0-.406-1.779,1.749,1.749,0,0,0-1.518-.164c-.793.261-1.5.8-2.273,1.141a14.012,14.012,0,0,1-2.824.967,2.757,2.757,0,0,1-3.4-2.456,9.309,9.309,0,0,1-.087-2.727c.329-2.244.793-4.468,1.2-6.692q1.654-9.1,3.356-18.21c.309-1.663.832-3.3.484-5.048a2.9,2.9,0,0,0-3.1-2.693l-.057,0ZM49.97,15.241A8.781,8.781,0,1,0,58.357,24.4c0-.064.006-.129.007-.192a8.7,8.7,0,0,0-8.394-8.946Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerVideo);
export default __webpack_public_path__ + "static/media/explainerVideo.1074e2498dc79292bd3d946e9badc9fe.svg";
export { ForwardRef as ReactComponent };